import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AuthenticatedApiClient } from '@guiker/task-shared'

export const useAuthApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
